export enum ProsecutionReturnNoteSection {
	RespondentData = 1,
	Facts = 2,
	Violations = 3,
	Introduction = 4,
	Reasons = 5,
	Requests = 6,
	Recommendation = 7,
}
